import { createReducer, on } from '@ngrx/store';
import { SearchedSheetItem } from 'src/app/services/sheets.service';
import * as authActions from '../auth/auth.actions';
import * as sheetItemSearchActions from './sheet-item-search.actions';

export interface State {
	queryTerm: string;
	newSearchInProgress: boolean;
	searchResults: SearchedSheetItem[];
	resultsPerAppend: number;
	appendsRetrieved: number;
	lastResultsRetrievedCount: number;
}

export const initialState: State = {
	queryTerm: '',
	newSearchInProgress: false,
	searchResults: [],
	resultsPerAppend: 50, // this is a constant value, change this if more results should be displayed per fetch. Be careful setting it too low, if one page doesn't fill the scrollable parent, the infinite scroll will not fire
	appendsRetrieved: 0,
	lastResultsRetrievedCount: 0
}

export const sheetItemSearchReducer = createReducer(
	initialState,
	on(sheetItemSearchActions.newSearchRequested, (state, { queryTerm }) => ({
		...state,
		queryTerm: queryTerm,
		newSearchInProgress: true,
		searchResults: [],
		appendsRetrieved: 0,
		lastResultsRetrievedCount: 0
	})),
	on(sheetItemSearchActions.newSearchSucceeded, (state, { searchResults }) => ({
		...state,
		newSearchInProgress: false,
		searchResults: searchResults,
		lastResultsRetrievedCount: searchResults.length
	})),
	on(sheetItemSearchActions.newSearchFailed, () => initialState),
	on(sheetItemSearchActions.appendResultsSucceeded, (state, { searchResults }) => ({
		...state,
		searchResults: [...state.searchResults, ...searchResults],
		appendsRetrieved: state.appendsRetrieved + 1,
		lastResultsRetrievedCount: searchResults.length
	})),
	on(sheetItemSearchActions.appendResultsFailed, () => initialState),
	on(sheetItemSearchActions.resultsCleared, () => initialState),
	on(sheetItemSearchActions.searchedSheetItemSelected, () => initialState),
	on(authActions.clearStateRequested, () => initialState)
);